import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的APP浮窗配置ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  title: [
    {...makeRule('请输入标题', 'string', 'blur', true)},
  ],
  img_url: [
    {...makeRule('请上传封面图片', 'string', 'blur', true)},
  ],
  target_type: [
    {...makeRule('请选择小浮窗事件', 'number', 'blur', true)},
  ],
  target_url: [
    {...makeRule('请输入落地页路径', 'string', 'blur', true)},
  ],
  launch_time_range: [
    {...makeRule('请选择上下线时间', 'array', 'blur', true)},
  ],
  user_currentstatus: [
    {...makeRule('请选择展示对象', 'array', 'blur', true)},
  ],
}



// WEBPACK FOOTER //
// ./src/views/app-popup/app-popup.rules.js